/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.phone-badge-check\":\"Smartphone och ett emblem med bock\"}");